import { Subject } from 'rxjs';

export interface DomRectMock {
  bottom?: number;
  height?: number;
  left?: number;
  right?: number;
  top?: number;
  width?: number;
  x?: number;
  y?: number;
}

const resizeEmitter: Subject<void> = new Subject();

let currentSize: DomRectMock = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0,
};

export class ResizeObserverMock {
  private targets: Element[] = [];

  constructor(
    public callback: (
      entries: ResizeObserverEntry[],
      observer: ResizeObserver,
    ) => void,
  ) {
    resizeEmitter.subscribe(() => {
      this.callback(
        this.targets.map(
          (a) =>
            ({
              devicePixelContentBoxSize: [
                { inlineSize: 666, blockSize: 666 } as ResizeObserverSize,
              ],
              target: a,
              contentRect: {
                ...currentSize,
                toJSON: () => JSON.stringify(currentSize),
              } as DOMRectReadOnly,
              borderBoxSize: [
                { inlineSize: 666, blockSize: 666 } as ResizeObserverSize,
              ],
              contentBoxSize: [
                { inlineSize: 666, blockSize: 666 } as ResizeObserverSize,
              ],
              devicePixelContentSize: [
                { inlineSize: 666, blockSize: 666 } as ResizeObserverSize,
              ],
            }) as ResizeObserverEntry,
        ),
        this,
      );
    });
  }

  public static triggerResize(size: DomRectMock): void {
    currentSize = {
      bottom: size.bottom ? size.bottom : 0,
      height: size.height ? size.height : 0,
      left: size.left ? size.left : 0,
      right: size.right ? size.right : 0,
      top: size.top ? size.top : 0,
      width: size.width ? size.width : 0,
      x: size.x ? size.x : 0,
      y: size.y ? size.y : 0,
    };

    resizeEmitter.next();
  }

  public observe(target: Element, _options?: ResizeObserverOptions): void {
    this.targets.push(target);
  }

  public unobserve(target: Element): void {
    this.targets.splice(this.targets.indexOf(target), 1);
  }

  public disconnect(): void {
    this.targets = [];
    // Mock implementation.
  }
}
